export default __webpack_public_path__ + "static/media/logo.67df35c0.png";